import { Component, OnInit, Input, TemplateRef} from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { LocationSearch} from 'src/app//models/locations';
import { emptyFields} from 'src/app/utilities/common-file';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { Messages } from 'src/app/utilities/message';
import { CommonService } from 'src/app/utilities/common-service';
 import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AuthService } from 'src/app/auth/auth.service';
import { ProductService } from '../../product.service';

@Component({
  selector: 'app-available-location',
  templateUrl: './available-location.component.html',
})
export class AvailableLocationComponent implements OnInit {

  @Input() product: any; // for data get from the drawer component
  data: any;
  loading = false;
  emptyField = emptyFields;
  isAvailable = false;
  productModal: NzModalRef;
  commentForm: UntypedFormGroup;
   showAppCodeFilter = false;

 private tableData: NzTableData<LocationSearch, any> = new NzTableData<LocationSearch, any>(new LocationSearch(), 'fullName');
  constructor(
    private fb: UntypedFormBuilder, 
    private productService: ProductService,
    private modal: NzModalService, 
    private notification: NzNotificationService,
    private commonService: CommonService,
    private authService: AuthService, 
    private drawerRef: NzDrawerRef<string>) { 
      this.commentForm = this.fb.group({
        comments: [''],
        isAvailable: [],
      });
    }

  ngOnInit() {
    this.refresh();
    // this.showAppCodeFilter = this.authService.showAppCodeFilter();
    this.data = this.product;
  }
 // For List
 refresh(startFromPageOne: boolean = true): void {
  this.loading = true;
  this.tableData.data = [];
  if (startFromPageOne) {
    this.tableData.pageIndex = 1;
  }
  this.tableData.pageSize = 5;
  this.tableData.search.merchant = this.product.merchantId;
  this.tableData.search.productId = this.product.id;
  this.tableData.search.appCode = this.product.appCode;
  this.productService.assignMerchantProductLocationList(this.tableData).subscribe((response: any) => {
    this.loading = false;
    this.tableData.total = response.data.total;
    this.tableData.data = response.data.merchantLocationProducts;
    // if (this.selectedLocation) {
    //   this.commentForm.patchValue(this.selectedLocation);
    //   }
}, err => {
  this.loading = false;
  this.tableData.data = [];
  this.tableData.total = 0;
});
}
// For Page Index change
onIndexChange(event) {
  this.tableData.pageIndex = event;
  this.refresh(false);
}
 // To Show Status
 getStatus(status) {
  return this.commonService.getStatus(status);
}
// To get color
getAvailableColor(value) {
  return this.commonService.getAvailableColor(value);
 }
 // For User Status Tag color
 getStatusColor(status) {
  return this.commonService.getStatusColor(status);
}
 // To Close drawer
 close(): void {
  this.drawerRef.close();
}
 //Get Currency 
 getMerchantCurrency(code){
  return  this.commonService.getCurrencySymbol(code);
}
 // Merchant Product Assign Location popup confirmation
 editassignLocation(
  row,
  merchantProductAssignLocationModal: TemplateRef<{}>
) {
  this.commentForm.patchValue(row);
  this.productModal = this.modal.create({
    nzContent: merchantProductAssignLocationModal,
    nzClosable: false,
    nzMaskClosable: false,
    nzOkText: 'Yes',
    nzOnOk: () => this.updateAssignLocation(row),
    nzCancelText: 'No',
    nzOnCancel: () => console.log('Cancel')
  });
}

destroyModal() {
  this.productModal.destroy();
}
  // Update Assign Location API
  updateAssignLocation(data) {
    const args = {
      merchantId: data.merchantId,
      productId: this.product.id,
      appCode: this.tableData.search.appCode,
      locationId: data.locationId,
      isAvailable: this.commentForm.value.isAvailable,
      comments: this.commentForm.value.comments,
    }
    this.productService.editMerchantProductLocation(data.id, args).subscribe(
      (res) => {
        this.refresh();
        this.notification.success(Messages.updated, '', {
          nzKey: 'key'
        });
      },
      (error) => {
      });
  }
   // Delete confirmation popup
   assignLocationDelete(item) {
    this.modal.confirm({
      nzTitle: 'Are you sure you want remove Merchant Product ' + item.productName + ' from Location ' + item.locationName + ' ?',
      nzOkText: 'Yes',
      nzOkType: 'danger',
      nzOnOk: () => this.deleteProductLocation(item),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel')
    });
  }
  // Delete API
  deleteProductLocation(item) {
    this.productService.deleteMerchantProductLocation(item.id).subscribe((response: any) => {
      this.notification.success(response.message, '', {
        nzKey: 'key'
      });
      this.refresh();
    }, err => {

    });
  }
   // For getting Appcode name
  //  getAPPCode(data) {
  //   return this.authService.getAppCodeName(data);
  // }
  
}
